import React from "react";
import Button from "../components/Button";

import animationData from "../animation/filter.json";
import Lottie from "lottie-react";
import { Link } from "react-router-dom";

const BrandingSection2 = () => {
  return (
    <div className="flex xl:px-35 px-10 flex-col xl:flex-row items-center h-fit justify-between dark:text-white py-20 pointer-events-auto xl:gap-40 gap-10">
      <div className="xl:w-[40vw]  ">
        <div className="flex justify-center items-center ">
          {/* <Lottie animationData={animationData} loop autoplay style={{ width: "40vw", height: "40vw" }} /> */}
          <img
            src="/new-final-data/branding-page/WOLFFF.webp"
            className="w-full xl:w-[40vw] "
            alt=""
          />
        </div>
      </div>
      <div className=" xl:w-[40vw] space-y-5 ">
        <div className="">
          <h3 className="text-sm text-[#EE005B] md:mb-4 xl:mb-0">
            PROBLEM DETECTED!
          </h3>
          <h1 className="text-4xl font-bold ">
            Your website should fly, <br /> and we can help you.
          </h1>
        </div>
        <div className="">
          <p className="text-md dark:text-zinc-200 text-zinc-700 ">
            Your website must offer a fast and uninterrupted experience, every
            second counts to retain your visitors. We have the perfect solution
            to optimise the speed of your site, ensuring that every user enjoys
            a smooth and efficient navigation.
          </p>
        </div>
        <div>
          <h2 className="text-md font-semibold">Performance estimation</h2>
        </div>

        {/* Progress Section */}
        <div className="w-full relative ">
          <div
            style={{ left: "calc(98% - 1.5rem)" }}
            className="absolute -top-[400%] flex justify-end items-center "
          >
            <span className="text-sm font-bold dark:text-white dark:bg-zinc-800 bg-zinc-200 py-[2px]  px-2 rounded-xl">
              98%
            </span>
          </div>
          <div className="w-full h-2 dark:bg-gray-600 bg-zinc-300 rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-[#D70A31] to-[#7945DB] transition-all duration-700 ease-out"
              style={{ width: `98%` }}
            ></div>
          </div>
        </div>
        <Link
          to={"/contact"}
          className="w-full mx-auto flex xl:inline justify-center items-center"
        >
          <Button>Analyse your performance now</Button>
        </Link>
      </div>
    </div>
  );
};

export default BrandingSection2;
